import { render, staticRenderFns } from "./payment-bill-receipt.vue?vue&type=template&id=4b9d3912&"
import script from "./payment-bill-receipt.vue?vue&type=script&lang=js&"
export * from "./payment-bill-receipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports